<template>
  <div id="app">
    <component :is="layout">
      <router-view :layout="layout" />
    </component>
    <SessionTimeoutWarning />
  </div>
</template>

<script>
import SessionTimeoutWarning from "@/components/auth/SessionTimeoutWarning";

export default {
  name: "App",
  components: { SessionTimeoutWarning },
  data() {
    return {
      layout: "div",
    };
  },
  mounted() {},
};
</script>
<style></style>
